import { Box, Typography, Chip } from "@mui/material";
import EducationContentIcons from "../../components/v2/education-content-icons/EducationContentIcons";
import { useTranslation } from "react-i18next";
import NoImageThumbnail from "../../assets/icons/learning_no_image.svg";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import styles from "./InFocusContent.module.scss";
import CheckedCircleIcon from "../../components/icon-components/CheckedCircleIcon";

interface InFocusDesktopCardProps {
  imageSrc: string;
  title: string;
  subtitle?: string;
  contentType: string;
  isNew?: boolean;
  activityPoints?: number;
  duration?: number;
  isCompleted?: boolean;
  activityCompletionStatus: string;
  onClick: () => void;
}

const InFocusDesktopCard: React.FC<InFocusDesktopCardProps> = ({
  imageSrc,
  title,
  subtitle,
  contentType,
  isNew,
  activityPoints,
  duration,
  isCompleted, 
  onClick,
}) => {
  const { t } = useTranslation();
  
  return (
    <Box className={styles.inFocusCardWrapper}>
      {/* Left image */}

      <Box
        className={styles.leftImage}
        style={{
          backgroundImage: imageSrc ? `url(${imageSrc})` : "none",
          paddingRight: imageSrc ? "0px" : "60px",
          backgroundColor: !imageSrc ? "#eaf0f0" : undefined,
        }}
      >
        {!imageSrc && (
          <img
            src={NoImageThumbnail}
            alt={title}
            style={{ width: 80, height: 80 }}
          />
        )}
        {isNew && (
          <Chip label={t("educationContent.new")} className={styles.newChip} />
        )}
      </Box>

      {/* Right content */}
      <Box className={styles.rightContent}>
        {isCompleted ? (
          <Box className={styles.completedBox}>
            <CheckedCircleIcon width={20} height={20} variant={"completed"} />
          </Box>
        ) : (
          <Box className={styles.activityPointsBox}>
            <Typography variant="body2" fontWeight={"bold"}>
              + {activityPoints}
            </Typography>
          </Box>
        )}

        <Box className={styles.contentTextBox}>
          <Typography variant="bodySmall" className={styles.inFocusLabel}>
            {t("educationContent.inFocusDesktop")}
          </Typography>

          <Typography variant="h4" mt={1}>
            {title}
          </Typography>

          <Box display="flex" alignItems="center" mt={1} mb={2}>
            <EducationContentIcons
              type={contentType}
              height={16}
              width={17}
              color="#4E7E6E"
            />
            <Typography variant="body2" paddingLeft={1}>
              {contentType === "videos" && (
                <>
                  {t("video")}
                  {duration
                    ? ` | ${duration} ${t("educationContent.min")}`
                    : ""}
                </>
              )}
              {contentType === "articles" && t("article")}
              {contentType === "URL" && t("URL")}
            </Typography>
          </Box>

          <Typography variant="body1" className={styles.descriptionText}>
            {subtitle}
          </Typography>

          <CustomButton
            variant="contained"
            className={styles.button}
            text={
              {
                videos: t("carePlan.watch"),
                articles: t("carePlan.read"),
                URL: t("educationContent.open"),
              }[contentType] || t("educationContent.open")
            }
            onClick={onClick}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default InFocusDesktopCard;

